export default {"src":"/_next/static/media/logo.03e46787.svg","height":32,"width":16,"blurWidth":0,"blurHeight":0};